import React from 'react';
import PropTypes from 'prop-types';
import DialogsWithIcon from '@Containers/Dialogs/DialogsWithIcon';
import Button from '@Components/Button';

import './TooManySessionsModal.scss';

function TooManySessionsModal({ close }) {
  return (
    <DialogsWithIcon
      size="sm"
      movable={false}
      className="react-dialogs-scrollable too-many-sessions-modal"
      headerClassName="too-many-sessions-modal__header"
      contentClassName="too-many-sessions-modal__content"
      layoutType="info"
      character="i"
      closeBtn={false}
      header={(
        <div className="too-many-sessions-modal__header_text">
          We have detected too many concurrent authentication requests
          from this workstation. Please wait 30
          seconds and then try again.
        </div>
    )}
    >
      <Button
        buttonConfig={{
          type: 'primary',
          size: 'sm',
          label: 'Close',
          e2eName: 'forgot-password-close',
        }}
        iconConfig={{
          name: 'chevron-right',
          size: 'sm',
        }}
        onClick={close}
      />
    </DialogsWithIcon>
  );
}
TooManySessionsModal.propTypes = {
  close: PropTypes.func.isRequired,
};

export default TooManySessionsModal;
